import React, { useContext } from 'react';
import { Search, Bell, Moon, Sun, LogOut } from 'lucide-react';
import { ThemeContext } from '../../context/ThemeContext';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const Header = ({ toggleSidebar }) => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  const navigate = useNavigate(); // Initialize useNavigate

  const handleLogout = () => {
    // Clear any authentication tokens from localStorage
    localStorage.removeItem('authToken'); // Assuming 'authToken' is used
    // Navigate to the admin login page
    navigate('/');
  };

  return (
    <header className="flex items-center justify-between px-6 py-4 bg-white dark:bg-slate-900 border-b-4 border-indigo-600 dark:border-slate-700 transition-colors">
      <div className="flex items-center">
        <button onClick={toggleSidebar} aria-label="Toggle sidebar" className="text-gray-500 dark:text-gray-200 focus:outline-none mr-3">
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6H20M4 12H20M4 18H11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div className="relative mx-4 lg:mx-0">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3">
            <Search className="w-5 h-5 text-gray-500" />
          </span>
          <input className="w-32 pl-10 pr-4 text-indigo-600 dark:text-indigo-300 border-gray-200 dark:border-slate-700 rounded-md sm:w-64 focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500 bg-white dark:bg-slate-800" type="text" placeholder="Search" />
        </div>
      </div>

      <div className="flex items-center">
        <button onClick={toggleTheme} aria-label="Toggle theme" className="flex mx-4 text-gray-600 dark:text-gray-200 focus:outline-none">
          {theme === 'light' ? <Moon className="w-6 h-6" /> : <Sun className="w-6 h-6" />}
        </button>
        <button className="flex mx-4 text-gray-600 focus:outline-none">
          <Bell className="w-6 h-6" />
        </button>
        <div className="relative">
          <button className="relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none">
            <img className="object-cover w-full h-full" src="https://images.unsplash.com/photo-1528892952291-009c663ce843?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=296&q=80" alt="Your avatar" />
          </button>
        </div>
        <div className="relative">
          <button onClick={handleLogout} className="relative z-10 block w-8 h-8 overflow-hidden rounded-full shadow focus:outline-none"> {/* Added onClick handler */}
            <LogOut className="w-5 h-5 text-gray-500" />
            <span className="hidden sm:inline">Logout</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
